import type { ComponentProps, JSX, PropsWithChildren } from 'react';

import { ThemeUIProvider } from 'theme-ui';

import type { Theme as LegacyDSTheme } from '@change-corgi/design-system-legacy/theme';
import { __internal_theme__ } from '@change-corgi/design-system-legacy/theme';

type ThemeUIThemeProp = ComponentProps<typeof ThemeUIProvider>['theme'];

export function DesignSystemLegacy({
	children,
	theme,
}: PropsWithChildren<{ theme?: LegacyDSTheme | ((theme: LegacyDSTheme) => LegacyDSTheme) }>): JSX.Element {
	return (
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/no-unsafe-type-assertion
		<ThemeUIProvider theme={(theme as ThemeUIThemeProp) || __internal_theme__}>{children}</ThemeUIProvider>
	);
}
